import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { UserService } from '../user.service';
import * as userActions from './user.actions';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { User } from '../../_models/user';
import { of } from 'rxjs';

@Injectable()
export class UserEffects {

    @Effect()
    loadUsers$ = this.actions$.pipe(
        ofType(userActions.UserActitonTypes.LoadUsers),
        mergeMap((action: userActions.LoadUsers) => this.userService.getAllUsers({actived: true, searchDesc: '', searchName: '' }).pipe(
            map((users: User[]) => (new userActions.LoadSuccessUsers(users))),
            catchError(err => of(new userActions.LoadFailUsers(err)))
        ))
    )

    constructor(private actions$: Actions,
                private userService: UserService) {

    }

    // @Effect()
    // setCurrentUser$ = this.actions$.pipe(
    //     ofType(userActions.UserActitonTypes.SetCurrentUser),
    //     mergeMap((action: userActions.SetCurrentUser) => this.userService.getAllUsers({actived: true, searchDesc: '', searchName: '' }).pipe(
    //         map((users: User[]) => (new userActions.LoadSuccessUsers(users))),
    //         catchError(err => of(new userActions.LoadFailUsers(err)))
    //     ))
    // )
}
